import { useTranslation } from 'react-i18next';
import { Navigate, Outlet } from 'react-router';
import { useSession } from '../../lib/session';

export function RequireAuth() {
  const { t } = useTranslation();
  const { loading, identity } = useSession();
  if (loading) return <p className="text-slate-500">{t('app.loading')}</p>;
  if (!identity)
    return <Navigate to={`/login?next=${encodeURIComponent(window.location.pathname)}`} replace />;
  return <Outlet />;
}
export function RequireSuperAdmin() {
  const { identity } = useSession();
  if (identity && !identity.superAdmin) return <Navigate to="/" replace />;
  return <Outlet />;
}
